import React, { useEffect, useState } from "react";
import { Table, Button,Modal  } from "react-bootstrap";
import { FaArrowLeft, FaCalendar, FaCheck, FaInfo, FaInfoCircle, FaQuoteRight } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import './orders.css';
import OrderTracker from "../Vendor/OrderTracker";
import { FaFileInvoice, FaSyncAlt, FaEdit, FaCalendarAlt } from "react-icons/fa"
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import Messages from "../layout/messages";

const OrderDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const Orders_data = state?.rfq;
const [showActionModal, setShowActionModal] = useState(false);
const [actionType, setActionType] = useState(""); 
const [updatedProducts, setUpdatedProducts] = useState([]);
const [newDeliveryDate, setNewDeliveryDate] = useState("");
  const [currentStep, setCurrentStep] = useState(-1);
  const [statusLabel, setStatusLabel] = useState("Quotation Approved");
  const [progress, setProgress] = useState(0);
  const [showInvoice, setShowInvoice] = useState(false);
  const created = Orders_data?.created;
  const delivery = Orders_data?.delivery_date;
  const status = Orders_data?.status;
const [showMessages, setShowMessages] = useState(false);
const [chatContext, setChatContext] = useState({
  rfq: null,
  supplier: null,
});
const [isCompleted, setIsCompleted] = useState(false);
const [loader, setLoader] = useState(false);

const [orderQueryCount, setOrderQueryCount] = useState(0);
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

useEffect(() => {
  if (!Orders_data?.id_rfq) return;

  const fetchQueryCount = async () => {
    try {
      const res = await apicall.get(
        `order/query-count?rfq_id=${Orders_data.id_rfq}&user_id=${userDetails.id}`
      );
    if (res.success && res.data?.length > 0) {
        setOrderQueryCount(res.data[0].total);
      } else {
        setOrderQueryCount(0);
      }
    } catch (err) {
      console.error("Failed to fetch order query count");
    }
  };

  fetchQueryCount();
}, [Orders_data]);

  useEffect(() => {
    if (!Orders_data) return;

    const stepMap = { 3: 0, 6: 1, 7: 2, 8: 3, 9: 4, 10: 5 ,15:5};
    const step = stepMap[Orders_data.status] ?? 0;
    setCurrentStep(step);

    const statusMap = {
      3: "Quotation Approved",
      6: "Awarded",
      7: "Invoice Raised",
      8: "Shipped",
      9: "Out for Delivery",
      10: "Delivered",
      15: "Completed",
      4: "Rejected",
    };
    setStatusLabel(statusMap[Orders_data.status]);
    setProgress(((step + 1) / 6) * 100);
  }, [Orders_data]);

  const getBadgeColor = () => {
    switch (statusLabel) {
      case "Delivered":
        return "bg-success";
      case "Rejected":
        return "bg-danger";
      case "Pending":
        return "bg-warning";
      default:
        return "bg-primary";
    }
  };
  const handleCloseInvoice = () => setShowInvoice(false);
  const openModifyModal = () => {
  setActionType("modify");
  setUpdatedProducts(
    Orders_data.products.map(p => ({
      product_id: p.product_id,
      quantity: p.quantity
    }))
  );
  setShowActionModal(true);
};
const formatDateForInput = (dateString) => {
  if (!dateString) return "";

  const d = new Date(dateString);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const openRescheduleModal = () => {
  setActionType("reschedule");
  setNewDeliveryDate(formatDateForInput(Orders_data?.delivery_date));
  setShowActionModal(true);
};


const closeActionModal = () => {
  setShowActionModal(false);
};

  const handleQuantityChange = (index, value) => {
  const updated = [...updatedProducts];
  updated[index].quantity = value;
  setUpdatedProducts(updated);
};

const handleSubmitAction = async () => {
  try {
    const payload =
      actionType === "modify"
        ? {
            rfq_id: Orders_data.id_rfq,
            products: updatedProducts
          }
        : {
            rfq_id: Orders_data.id_rfq,
            delivery_date: newDeliveryDate
          };

    const url =
      actionType === "modify"
        ? "update-quantity"
        : "reschedule-delivery";

    const res = await apicall.post(payload,url)
    if(res.success){
      toast.success(res.message);
      setShowActionModal(false);

    }

    window.location.reload();
  } catch (err) {
    alert("Something went wrong");
  }
};
const openChatWindow = (supplierId) => {
  const context = {
    Orders_data,
    supplier: supplierId,
    context: "ORDER" 
  };

  localStorage.setItem("chatContext", JSON.stringify(context));

  // open chat in new tab
  window.open("/chat", "_blank");
};
const handleUpdate = async (status) => {

  try {
    setLoader(true)
    const body = {
      rfq_id: Orders_data?.id_rfq,
      supplier_id: Orders_data?.supplier_id,
      status,
    };

    const res = await apicall.post(body, "updateQuotationStatus");

    if (res.success) {
      toast.success(res.message);
      //  setIsCompleted(true); 
      // navigate('/orders')
    } else {
      toast.error(res.message || "Update failed");
    }
  } catch (error) {
    console.error("Error updating status:", error);
    toast.error("Something went wrong");
  } finally{
        setLoader(false)

  }
};
  return (
    <div className="container my-4">
      <div className="mb-3">
        <p className="fw-semibold">
          <FaArrowLeft
            className="me-2 cursor-pointer"
            size={20}
            onClick={() => navigate(-1)}
          />
          Back to Dashboard
        </p>
      </div>

      <div className="row g-3">
        <div className="col-lg-8">
          <div className="card p-3 mb-3 shadow-sm" style={{ borderRadius: "10px" }}>
            <div className="d-flex justify-content-between align-items-center">
              <h6 className=" mb-0">Order Status</h6>
              <div>
                <span className={`badge ${getBadgeColor()} me-2`}>{statusLabel}</span>
                {status < 10 && <span className="badge bg-secondary"></span>}
              </div>
            </div>

            <div className="text-muted small mt-2">
              Tracking Number: <strong>{Orders_data?.display_order_id}-{Orders_data?.display_id}</strong>
            </div>

            <div className="progress mt-3" style={{ height: "10px", borderRadius: "5px" }}>
              <div
                className="progress-bar"
                role="progressbar"
                style={{
                  width: `${progress}%`,
                  background: "linear-gradient(90deg, #16a34a, #4ade80)",
                  transition: "width 0.5s ease-in-out"
                }}
              ></div>
            </div>

            <div className="d-flex justify-content-between text-muted small mt-2">
              <div><strong>Order Date:</strong> {created ? new Date(created).toLocaleDateString("en-GB") : "-"}</div>
              <div><strong>Expected Delivery:</strong> {delivery ? new Date(delivery).toLocaleDateString("en-GB") : "-"}</div>
            </div>
          </div>

          {currentStep !== -1 && <OrderTracker currentStep={currentStep} OrdersData={Orders_data}/>}

          <div className="card p-3 mb-3">
            <h6 className=" mb-3">Order Details</h6>
            {Orders_data?.products?.map((p, i) => (
              <div key={i} className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <div className="fw-semibold">{p.item}</div>
                  <div className="text-muted small">
                    Qty: {p.quantity} × ${p.price?.toLocaleString()}
                  </div>
                </div>
                <div className="fw-semibold">${p.amount?.toLocaleString()}</div>
              </div>
            ))}
            <hr />
            <div className="text-end ">
              Total Amount: <span className="text-success">${Orders_data?.total_price?.toLocaleString()}</span>
            </div>
          </div>
        </div>

        

        <div className="col-lg-4">
<div className="card p-3 mb-3">
  <h6 className=" mb-2">Quick Actions</h6>

  {/* View Invoice */}
  <button
    className="btn w-100 mb-2 d-flex align-items-center justify-content-start"
    style={{
      border: "1px solid #dee2e6",
      backgroundColor: "transparent",
    }}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor = "#d01c4c";
      e.target.style.color = "white";
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = "transparent";
            e.target.style.color = "black";

    }}
    onClick={()=>setShowInvoice(true)}
  >
    <FaFileInvoice style={{ marginRight: 10 }} />
    View Invoice
  </button>

  {/* Refresh Status */}
  <button
    className="btn w-100 mb-2 d-flex align-items-center justify-content-start"
    style={{
      border: "1px solid #dee2e6",
      backgroundColor: "transparent",
    }}
    onClick={() => window.location.reload()}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor = "#d01c4c";
      e.target.style.color = "white";
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = "transparent";
            e.target.style.color = "black";

    }}
  >
    <FaSyncAlt style={{ marginRight: 10 }} />
    Refresh Status
  </button>

  {/* Modify Order */}
  <button onClick={openModifyModal}
    className="btn w-100 mb-2 d-flex align-items-center justify-content-start"
    style={{
      border: "1px solid #dee2e6",
      backgroundColor: "transparent",
    }}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor = "#d01c4c";
      e.target.style.color = "white";
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = "transparent";
            e.target.style.color = "black";

    }}
    
  >
    <FaEdit style={{ marginRight: 10 }} />
    Modify Order
  </button>

 <button
  onClick={() => handleUpdate(15)}
  disabled={Orders_data?.status === "15"}
  className="btn w-100 mb-2 d-flex align-items-center justify-content-start"
  style={{
    border: "1px solid #dee2e6",
    backgroundColor: isCompleted ? "#e9ecef" : "transparent",
    color: isCompleted ? "#6c757d" : "black",
    cursor: isCompleted ? "not-allowed" : "pointer",
  }}
  onMouseEnter={(e) => {
    if (!isCompleted) {
      e.currentTarget.style.backgroundColor = "#d01c4c";
      e.currentTarget.style.color = "white";
    }
  }}
  onMouseLeave={(e) => {
    if (!isCompleted) {
      e.currentTarget.style.backgroundColor = "transparent";
      e.currentTarget.style.color = "black";
    }
  }}
>
  <FaCheck style={{ marginRight: 10 }} />
  {Orders_data?.status === "15" ? "Completed" : loader ? "Conforming...": "Confirm Delivery"}
</button>


  {/* Reschedule Delivery */}
  <button onClick={openRescheduleModal}
    className="btn w-100 d-flex align-items-center justify-content-start"
    style={{
      border: "1px solid #dee2e6",
      backgroundColor: "transparent",
    }}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor = "#d01c4c";
      e.target.style.color = "white";
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = "transparent";
            e.target.style.color = "black";

    }}
  >
    <FaCalendar style={{ marginRight: 10 }} />
    Reschedule Delivery
  </button>

  <button
  className="btn w-100 d-flex align-items-center justify-content-start"
  style={{
    border: "1px solid #dee2e6",
    backgroundColor: "transparent",
  }}
  onMouseEnter={(e) => {
    e.target.style.backgroundColor = "#d01c4c";
    e.target.style.color = "white";
  }}
  onMouseLeave={(e) => {
    e.target.style.backgroundColor = "transparent";
    e.target.style.color = "black";
  }}
   onClick={() => openChatWindow(Orders_data?.supplier_id)}

//  onClick={() => {

//     setChatContext({
//       rfq: {
//         id: Orders_data?.id_rfq,
//         title: Orders_data.company,
//         user: Orders_data.user,
//       },
//       supplier: Orders_data?.supplier_id,
//       context: "ORDER"
//     });

//     setShowMessages(true);
//   }}
>
      <FaInfoCircle style={{ marginRight: 10 }} />
    Request More Information

  {orderQueryCount > 0 && (
    <span className="badge bg-danger ms-2">
      {orderQueryCount}
    </span>
  )}
</button>
{/* <Messages
  show={showMessages}
  onClose={() => setShowMessages(false)}
  initialRFQ={chatContext.rfq}
  initialSupplier={chatContext.supplier}
  chatContext={chatContext?.context}
/> */}

</div>

        <div className="card p-3 mb-3">
  <h6 className=" mb-2">Supplier Information</h6>

  <p className="mb-1 fw-semibold">
    {Orders_data?.user_name || "N/A"}
  </p>

  <p className="small mb-1">
    {Orders_data?.user_email || "Not available"}
  </p>

  <p className="small mb-0">
    {Orders_data?.user_mobile || "Not available"}
  </p>
</div>

          <div className="card p-3 mb-3">
  <h6 className=" mb-3"># Order Summary</h6>

  <div className="d-flex justify-content-between mb-2">
    <span className="fw-semibold text-muted">RFQ Reference:</span>
    <span className="fw-semibold">{Orders_data?.rfq_reference || "RFQ-2025-00138"}</span>
  </div>
  <div className="d-flex justify-content-between mb-2">
    <span className="fw-semibold text-muted">Total Items:</span>
    <span className="fw-semibold">{Orders_data?.total_items}</span>
  </div>

 <div className="d-flex justify-content-between mb-2">
  <span className="fw-semibold text-muted">Total Quantity:</span>
  <span className="fw-semibold">
    {Array.isArray(Orders_data?.products)
      ? Orders_data.products.reduce(
          (total, p) => total + Number(p.quantity || 0),
          0
        )
      : 0}
  </span>
</div>


  <div className="d-flex justify-content-between">
    <span className=" fs-6">Total Amount:</span>
    <span className=" fs-6 text-success">
      ${Orders_data?.total_price?.toLocaleString() || "0"}
    </span>
  </div>
</div>

        
        </div>
      </div>
     <Modal
  show={showInvoice}
  onHide={handleCloseInvoice}
  size="lg"
  centered
  backdrop="static"
>
  <Modal.Header closeButton>
    <Modal.Title>Invoice Preview</Modal.Title>
  </Modal.Header>

  <Modal.Body style={{ minHeight: "70vh" }}>
    {Orders_data?.invoice_document_path?.length > 0 ? (
      Orders_data.invoice_document_path.map((file, index) => {
        // IMAGE PREVIEW
        if (file.match(/\.(jpeg|jpg|png|gif)$/i)) {
          return (
            <img
              key={index}
              src={file}
              alt={`Invoice ${index + 1}`}
              style={{
                maxWidth: "100%",
                marginBottom: 10,
                borderRadius: 5
              }}
            />
          );
        }

      if (file.match(/\.pdf$/i)) {
  return (
    <iframe
      key={index}
      src={`${file}#toolbar=0&navpanes=0&scrollbar=0`}
      title={`Invoice PDF ${index + 1}`}
      style={{
        width: "100%",
        height: "70vh",
        border: "none",
        borderRadius: 6,
        background: "#f5f5f5"
      }}
    />
  );
}


        // OTHER FILE TYPES (fallback)
        return (
          <a
            key={index}
            href={file}
            target="_blank"
            rel="noopener noreferrer"
            className="d-block mb-2"
          >
            {file.split("/").pop()}
          </a>
        );
      })
    ) : (
      <p className="text-center">No invoice available</p>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={handleCloseInvoice}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

      <Modal show={showActionModal} onHide={closeActionModal} centered>
  <Modal.Header closeButton>
    <Modal.Title>
      {actionType === "modify" ? "Modify Order Quantity" : "Reschedule Delivery"}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {actionType === "modify" && (
      <>
        {updatedProducts.map((p, i) => (
          <div key={i} className="mb-3">
            <label className="form-label">
              Product {i + 1} Quantity
            </label>
            <input
              type="number"
              className="form-control"
              value={p.quantity}
              min={1}
              onChange={(e) =>
                handleQuantityChange(i, e.target.value)
              }
            />
          </div>
        ))}
      </>
    )}

    {actionType === "reschedule" && (
      <>
        <label className="form-label">Select New Delivery Date</label>
        <input
          type="date"
          className="form-control"
          value={newDeliveryDate}
          onChange={(e) => setNewDeliveryDate(e.target.value)}
        />
      </>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={closeActionModal}>
      Cancel
    </Button>
    <Button className="btn-danger" onClick={handleSubmitAction}>
      Save
    </Button>
  </Modal.Footer>
</Modal>

    </div>
  );
};

export default OrderDetails;
